import { StyledToolbarButton, StyledTooltip } from '../../../../../shared/styles/components/integrations.styles';
import { useParentItemsFromSelectedSubItems, useSubItemsFromSelections } from '../../../state/selection.state';

import { ToastService } from '../../../../../services/toast.service';
import copyIcon from '@ingka/ssr-icon/paths/copy';
import { useCopyParts } from '../../../state/copy-paste.state';

export const CopyButton = () => {
    const selectedSubItems = useSubItemsFromSelections();
    const selectedParentItems = useParentItemsFromSelectedSubItems(true);
    const { copyParts } = useCopyParts();
    const selectableSubItems = selectedSubItems.filter((subItem) => subItem.clientCreated);

    const isAnySelected = selectableSubItems.length > 0;

    const onClick = () => {
        const copiedParentIds = new Set(selectableSubItems.map((subItem) => subItem.parentId));
        const selectableParentItems = selectedParentItems.filter((parent) => copiedParentIds.has(parent.itemNo));
        const families = new Set(selectableParentItems.map((p) => p.familyName));
        const family = families.size === 1 ? selectableParentItems[0]?.familyName : undefined;
        copyParts(selectableSubItems, family);

        const skippedCount = selectedSubItems.length - selectableSubItems.length;
        if (skippedCount > 0) {
            ToastService.info(`${skippedCount} non-user-created part(s) were skipped`);
        }

        ToastService.success(`${selectableSubItems.length} part(s) copied`);
    };

    return (
        <StyledTooltip title={isAnySelected ? 'Copy part(s)' : 'You need to select user created part(s) to copy'}>
            <span>
                <StyledToolbarButton
                    ssrIcon={copyIcon}
                    text="Copy"
                    iconOnly={true}
                    small={true}
                    onClick={onClick}
                    disabled={!isAnySelected}
                />
            </span>
        </StyledTooltip>
    );
};
